import React from 'react';
import { Helmet } from 'react-helmet-async';

const defaultKeywords = "ayurvedic ecommerce india, vihaanherbals, organic soap manufacturer india, ahmedabad ayurvedic products, small business india, vihaanherbals, vihaanherbal, vihaan, vihan, veehan, soap, soaps, ecommerce india, ahmedabad, small bussiness, hair oil, face wash, face oil, neem soap, sandle soap, chandan soap, multani mitti soap, de-tan soap, face cream, ayurveda, ayurvedic, 100% organic, organic, amazon, flipkart, zomato, free shipping, free delivery, free shipping in india, free delivery in india, free shipping in ahmedabad, free delivery in ahmedabad, free shipping in vihaanherbals, free delivery in vihaanherbals, vihaanherbals.in";

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical, 
  ogType = 'website', 
  ogImage, 
  schemaData 
}) => {
  const siteName = 'Vihaan Herbals';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const url = canonical || window.location.href;

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta name="keywords" content={keywords || defaultKeywords} />
      <link rel="canonical" href={url} />

      {/* OpenGraph tags */}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={url} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* Structured Data (JSON-LD) */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
